import { getPlatformFeatureFlags } from './getFeatureFlags';
import { appendResolvedResourceEntry } from './createSrcFromExtension';

export const getSrcUrl = (
	tunnels: { resourceKey: string; tunnelUrl: string }[],
	extensionResource: string,
	defaultUrl: string,
	urlSafeContext: string,
	resolvedResourceEntry?: string,
): string => {
	const matchTunnel = tunnels.find((tunnel) => tunnel.resourceKey === extensionResource);

	const platformFeatureFlags = getPlatformFeatureFlags();

	const queryParams = new URLSearchParams({
		...(platformFeatureFlags.length > 0
			? { platformFeatureFlags: platformFeatureFlags.join(',') }
			: {}),
		// when tunnelling, pass hostname into query param to be passed into CSP
		...(matchTunnel
			? {
					hostname: window.location.hostname,
					ctx: urlSafeContext,
				}
			: {}),
	}).toString();

	const query = queryParams ? `?${queryParams}` : '';

	if (matchTunnel) {
		return `${appendResolvedResourceEntry(matchTunnel.tunnelUrl, resolvedResourceEntry)}${query}`;
	}
	return `${defaultUrl}${query}`;
};

/**
 * Returns true when `src` points to a local tunnel — i.e. the iframe is loading
 * from the developer's machine via `forge tunnel`. Consumers can use this to
 * suppress production-only behaviour (e.g. analytics for unexpected reloads).
 */
export const isTunnelSrc = (src: string): boolean => {
	try {
		return new URL(src).hostname === 'localhost';
	} catch {
		return false;
	}
};
